import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/site/Form";
import { api, errMsg } from "@/lib/api";
import { SettingsPanel } from "./IntegrationStatus";

const FIELDS = [
  ["name", "Business name"], ["trading_name", "Trading name (shown in emails)"], ["address", "Address"], ["phone", "Telephone"],
  ["email", "Public email"], ["website", "Existing website"], ["stock_url", "Stock page ('Browse our cars')"],
];

export const BusinessSettings = ({ s, save, owner }) => {
  const [b, setB] = useState(s.business);
  const [to, setTo] = useState(s.notification_email);
  const test = async () => {
    try {
      const { data } = await api.post("/dealer/test-email");
      data.status === "sent" ? toast.success(`Test email sent to ${to}`) : toast.error(`Not sent: ${data.error}`);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-5">
      <SettingsPanel title="Business contact details" testid="business-settings">
        <div className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, label]) => (
            <Field key={k} label={label} htmlFor={`b-${k}`}><input id={`b-${k}`} className="field-input" value={b[k] || ""} disabled={!owner} onChange={(e) => setB({ ...b, [k]: e.target.value })} data-testid={`business-${k}-input`} /></Field>
          ))}
          <div className="sm:col-span-2"><Field label="Legal line (shown in the footer and privacy information)" htmlFor="b-legal"><textarea id="b-legal" rows={2} className="field-input" value={b.legal_line || ""} disabled={!owner} onChange={(e) => setB({ ...b, legal_line: e.target.value })} data-testid="business-legal-line-input" /></Field></div>
          <div className="sm:col-span-2"><Field label="Opening hours (optional, shown on the website)" htmlFor="b-hours"><textarea id="b-hours" rows={3} className="field-input" value={b.opening_hours || ""} disabled={!owner} onChange={(e) => setB({ ...b, opening_hours: e.target.value })} data-testid="business-hours-input" /></Field></div>
        </div>
        {owner && <Button onClick={() => save({ business: b })} data-testid="business-save-button">Save business details</Button>}
      </SettingsPanel>
      <SettingsPanel title="Enquiry notifications" testid="notification-settings">
        <Field label="Send new-enquiry emails to" htmlFor="notify" hint="Notifications contain the vehicle, reference and a dashboard link only – no customer photos.">
          <input id="notify" type="email" className="field-input" value={to} disabled={!owner} onChange={(e) => setTo(e.target.value)} data-testid="notification-email-input" />
        </Field>
        <p className="text-sm text-slate-600">Emails are sent from Emergent's verified sending address with the sender name "Harrington's Direct", and replies go to your public email. They are not sent from your AOL address.</p>
        {owner && <div className="flex gap-2"><Button onClick={() => save({ notification_email: to })} data-testid="notification-save-button">Save</Button><Button variant="outline" onClick={test} data-testid="test-email-button">Send test email</Button></div>}
      </SettingsPanel>
    </div>
  );
};
